
import React from "react";
import { UserHeader } from "./UserHeader";

interface UserDetailsErrorProps {
  onBack: () => void;
}

export const UserDetailsError: React.FC<UserDetailsErrorProps> = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-[#F8F8F8] flex flex-col">
      <UserHeader userName="Utilisateur non trouvé" onBack={onBack} />
      <div className="flex items-center justify-center flex-1">
        <p>Utilisateur non trouvé</p>
      </div>
    </div>
  );
};
